import { Card } from "@/components/ui/card";

import { fmtArr } from "../format";

export interface ChurnRow {
  label: string;
  /** Negative numbers expected (e.g. -222636). */
  arr: number | null;
}

export interface ChurnData {
  total: number | null;
  rows: ChurnRow[];
  netExpansionVsChurn: number | null;
  source?: string;
}

export function ChurnCard({
  periodLabel,
  data,
}: {
  periodLabel: string;
  data: ChurnData | null;
}) {
  return (
    <Card className="relative h-full overflow-hidden p-5">
      <div className="absolute left-0 top-0 h-full w-1 bg-danger" />
      <div className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
        Churn &amp; Contraction — {periodLabel}
      </div>
      <div className="mt-2 text-3xl font-extrabold tracking-tight tabular-nums text-danger">
        {data?.total != null ? `−${fmtArr(Math.abs(data.total), 0)}` : "—"}
      </div>

      <div className="mt-3 flex flex-col gap-1.5">
        {(data?.rows ?? PLACEHOLDER_ROWS).map((row, idx) => (
          <div key={idx} className="flex items-baseline justify-between text-xs">
            <span className="text-muted-foreground">{row.label}</span>
            <span className="font-semibold tabular-nums">
              {row.arr != null
                ? `−${fmtArr(Math.abs(row.arr), 0)} ARR`
                : "—"}
            </span>
          </div>
        ))}
        <div className="mt-1 flex items-baseline justify-between border-t border-border pt-2 text-xs">
          <span className="text-muted-foreground">
            Net expansion vs churn ({periodLabel})
          </span>
          <span
            className={
              data?.netExpansionVsChurn != null && data.netExpansionVsChurn < 0
                ? "font-semibold tabular-nums text-danger"
                : "font-semibold tabular-nums text-success"
            }
          >
            {data?.netExpansionVsChurn != null
              ? (data.netExpansionVsChurn < 0 ? "−" : "+") +
                fmtArr(Math.abs(data.netExpansionVsChurn), 0)
              : "—"}
          </span>
        </div>
      </div>

      <div className="mt-3 text-[9px] font-semibold uppercase tracking-wider text-muted-foreground/50">
        {data?.source ?? "Source TBD"}
      </div>
    </Card>
  );
}

const PLACEHOLDER_ROWS: ChurnRow[] = [
  { label: "Churn MRR × 12", arr: null },
  { label: "Contraction MRR × 12", arr: null },
];
